import React, { useEffect } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Footer from "../Footer";
import NavigationBar from "../navigation/NavigationBar";
import SidebarClinician from "../sidebars/SidebarClinician";
import InfoTabPatient from "../sharedInfoPageTabs/InfoTabPatient";
import InfoTabClinician from "../sharedInfoPageTabs/InfoTabClinician";
import ClinicianLogo from "../../img/user/clinician.png";
import PatientLogo from "../../img/user/patient.png";

interface InformationPageClinicianProps {
  title: string;
}

const InformationPageClinician = ({ title }: InformationPageClinicianProps) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
    <div className="min-vh-100" id="body">
      {/* navigation bar (bar on the top) */}
      <NavigationBar />
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar (bar on the side) */}
          <SidebarClinician />
          {/* Content */}
          <div className="col container p-3" id="main-content">
            <h3>Informationen zu SysDok</h3>
            <Tabs defaultActiveKey="clinician" className="mb-3">
              {/* for employees/ Für Mitarbeitende */}
              <Tab
                eventKey="clinician"
                title={
                  <div>
                    <i className="mdi">
                      <img
                        className="rounded-circle "
                        src={ClinicianLogo}
                        width="25px"
                        alt="Clinician"
                      />
                    </i>
                    <span> Für Mitarbeitende</span>
                  </div>
                }
              >
                <div className="m-3">
                  <InfoTabClinician />
                </div>
              </Tab>
              {/* for patients/ Für Patient*innen */}
              <Tab
                eventKey="patient"
                title={
                  <div>
                    <i className="mdi">
                      <img
                        className="rounded-circle "
                        src={PatientLogo}
                        width="25px"
                        alt="Patient"
                      />
                    </i>
                    <span> Für Patient*innen</span>
                  </div>
                }
              >
                <div className="m-3">
                  <InfoTabPatient />
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default InformationPageClinician;
